import { render } from "./EmailRecoverPage.vue?vue&type=template&id=68cf6be1&scoped=true&ts=true"
import script from "./EmailRecoverPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./EmailRecoverPage.vue?vue&type=script&lang=ts&setup=true"

import "./EmailRecoverPage.vue?vue&type=style&index=0&id=68cf6be1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68cf6be1"],['__file',"src/pages/login/EmailRecoverPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "68cf6be1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('68cf6be1', __exports__)) {
    api.reload('68cf6be1', __exports__)
  }
  
  module.hot.accept("./EmailRecoverPage.vue?vue&type=template&id=68cf6be1&scoped=true&ts=true", () => {
    api.rerender('68cf6be1', render)
  })

}


export default __exports__